<template>
  <div class="rounded-lg alerts-list elevation-3">
    <v-list>
      <div class="fixed-header">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="alert-categories-name">
              {{
                currentCategory.name
              }}
            </v-list-item-title>
            <v-list-item-subtitle class="alert-categories-description">
              {{ currentCategory.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-4" />
      </div>

      <div class="scrollable-alerts">
        <FleetAlertsList v-if="filteredAlertSettings.length" />
        <EmptyList
          v-else
          title="No Alerts Found"
          :message="emptyListMessage"
        />
      </div>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FleetAlertsList from "./components/List.vue";
import EmptyList from "../components/EmptyList.vue";
export default {
  name: "SuccessView",
  components: {
    FleetAlertsList,
    EmptyList,
  },
  computed: {
    ...mapState("fleetAlerts", ["selectedCategory", "categories"]),
    ...mapGetters("fleetAlerts", ["filteredAlertSettings"]),
    currentCategory() {
      return this.categories.find((cat) => cat.id === this.selectedCategory);
    },
    emptyListMessage() {
      return `There are no alerts configured for ${this.currentCategory.name}. Contact support to add alerts.`;
    },
  },
  methods: {},
};
</script>

    <style scoped>
.v-list {
  background-color: var(--color-surface) !important;
  position: relative;
}

.alerts-list {
  max-height: calc(100vh - 5em);
  overflow: hidden;
  margin: 16px;
  width: calc(100% - 2em);
  border-radius: 8px;
  background-color: var(--color-surface);
}

.fixed-header {
  position: sticky;
  top: 0;
  background-color: var(--color-surface);
  z-index: 1;
}

.scrollable-alerts {
  overflow-y: auto;
  max-height: calc(100vh - 15em);
  padding-bottom: 1em;
}

.alert-categories-name {
  color: var(--color-text) !important;
}

.alert-categories-description {
  color: var(--color-text-muted) !important;
}
</style>
